/// <reference path="skyward.ui.fieldset.ts"/>
/// <reference path="skyward.ui.modallayer.js"/>

(
    function (skyward, $, undefined)
    {
        "use strict";

        let blankValues = [undefined, null, ""];

        var init = function (selector)
        {
            $(selector).find(".promptTemplateSelector").each(function () { promptTemplateSelector().init($(this)); });
        };

        const promptElementsSelector = '.filterValue, .filterProcessingListValue, .CrystalReportParameterInput';

        function promptTemplateSelector()
        {
            let promptTemplateContainer;
            let promptElements;

            let reportId;
            let runUnpublishedVersion;
            let urlBase;

            let promptTemplateDetailsPopup;

            let codeEEL;

            let undoButton;
            let saveEditableFields;
            let saveButton;
            let saveAsNewButton;
            let allButtons;

            function init(promptTemplateSelector)
            {
                promptTemplateContainer = promptTemplateSelector.closest(".workflowContent");
                findAllPromptElements();

                const selectorData = promptTemplateSelector.data();
                urlBase = skyward.global.virtualDir + selectorData.area + '/' + selectorData.controller + '/';
                reportId = selectorData.reportId;
                runUnpublishedVersion = selectorData.runUnpublishedVersion;

                promptTemplateDetailsPopup = promptTemplateContainer.find('template.promptTemplateDetailsPopup');

                codeEEL = promptTemplateSelector.find(".promptTemplateCodeEEL.codeEELValue");
                codeEEL.on("change", loadPromptTemplate);

                undoButton = promptTemplateSelector.find(".promptTemplateUndoButton");
                undoButton.on("click", loadPromptTemplate);

                saveEditableFields = buildEditableFieldsHashDictionary(promptTemplateContainer.find(".SavePromptTemplateSecuredFields"));
                saveButton = promptTemplateSelector.find(".promptTemplateSaveButton");
                saveButton.on('click', save);

                saveAsNewButton = promptTemplateSelector.find(".promptTemplateSaveAsNewButton");
                saveAsNewButton.on('click', saveAsNew);

                allButtons = $(saveAsNewButton).add(saveButton).add(undoButton);

                promptTemplateContainer.on('change dirty update', promptElementsSelector, updateDirtyStatus);

                updateDirtyStatus();
            }

            function findAllPromptElements()
            {
                promptElements = promptTemplateContainer.find(promptElementsSelector);
            }

            // Functions
            function loadPromptTemplate(e)
            {
                if (codeEEL.val() !== "")
                {
                    skyward.workflow.customButtonAction("loadPromptTemplate");
                }
            }

            function buildEditableFieldsHashDictionary(el)
            {
                let editableFields = {};
                if (el.val())
                {
                    editableFields[el.data('hash')] = el.val();
                }
                return JSON.stringify(editableFields);
            }

            function save()
            {
                if (codeEEL.val())
                {
                    $.ajax({
                        url: urlBase + "UpdateValues",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            id: codeEEL.val(),
                            warninghash: "",
                            editableFields: saveEditableFields,
                            promptValuesJson: JSON.stringify(getPromptBoundValuesDictionary()),
                            reportId: reportId,
                            runUnpublishedVersion: runUnpublishedVersion
                        },
                        success: function (data)
                        {
                            if (data.success)
                            {
                                loadPromptTemplate();
                            }
                            else
                            {
                                skyward.validation.displayValidationMessages({ errors: data.errors }, promptTemplateContainer, $());
                            }
                        }
                    });
                }
            }

            function saveAsNew()
            {
                let dialog;
                let buttons = [{ text: "Save", icon: "Save", click: function () { doSaveAsNew().then(dialog.close); } }, { text: "Cancel", icon: "Cancel" }];
                dialog = skyward.modalLayer.showDialog("New Prompt Template", saveAsNewPromptTemplateDialog(), buttons, { anchorTo: saveAsNewButton, closeOnClick: false });

                let nameInput;
                let descriptionInput;

                dialog.bodyPromise.then(function ()
                {
                    nameInput = dialog.content.find(".saveAsNewPromptName");
                    descriptionInput = dialog.content.find(".saveAsNewPromptDescription");

                    descriptionInput.on('focus', function copyNameToDescription()
                    {
                        const description = descriptionInput.val();
                        if (description === null || description === "")
                        {
                            skyward.controls.setValue(descriptionInput, nameInput.val());
                        }
                    });

                    nameInput.focus();
                });

                function doSaveAsNew()
                {
                    const deferred = $.Deferred();

                    const name = skyward.controls.getValue(nameInput);
                    const description = skyward.controls.getValue(descriptionInput);

                    $.ajax({
                        url: urlBase + "SaveAsNew",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            warninghash: "",
                            reportId: reportId,
                            id: null,
                            name: name,
                            description: description,
                            promptValuesJson: JSON.stringify(getPromptBoundValuesDictionary()),
                            runUnpublishedVersion: runUnpublishedVersion
                        },
                        success: function (data)
                        {
                            const container = dialog.content;
                            const baseErrorContainer = container.find(".js-promptTemplateErrorMessageContainer");
                            skyward.validation.clearValidationMessages(container, baseErrorContainer);

                            if (data.success)
                            {
                                codeEEL.val(data.id);
                                loadPromptTemplate();
                                deferred.resolve();
                            }
                            else
                            {
                                skyward.validation.displayValidationMessages({ errors: data.errors }, container, baseErrorContainer);
                                deferred.reject();
                            }
                        },
                        error: deferred.reject
                    });

                    return deferred;
                }
            }

            function saveAsNewPromptTemplateDialog()
            {
                const temporaryContainer = $('<div/>', { class: "js-fieldset" }).css({ display: "hidden", position: "absolute", bottom: "0px" }).appendTo(document.body);

                const content = $(promptTemplateDetailsPopup.html());
                content.appendTo(temporaryContainer);

                skyward.fieldset.alignTitles(temporaryContainer);

                content.detach();

                temporaryContainer.remove();

                return content;
            }

            function updateDirtyStatus()
            {
                findAllPromptElements();
                allButtons.hide();

                const isDirty = skyward.changeTracking.isDirty(promptTemplateContainer) || promptElements.add(".CrystalReportParameterFS .multiSelectBackingData").is("[data-dirty='true']");
                const isNotBlank = atLeastOnePromptIsFilledIn();
                if (isDirty && codeEEL.val())
                {
                    if (isNotBlank)
                    {
                        saveButton.show();
                    }
                    undoButton.show();
                }

                if (isNotBlank)
                {
                    saveAsNewButton.show();
                }
            }

            function atLeastOnePromptIsFilledIn()
            {
                var typeSpecificTests =
                {
                    isBlankDuration: function (promptElement, promptElementData, value)
                    {
                        return promptElement.is(".durationpicker") && (promptElement[0].defaultValue === "0:00:00" && promptElement.val() === "0:00:00");
                    },
                    isUnchangedSortOrder: function (promptElement, promptElementData, value)
                    {
                        return promptElement.hasClass("listSortOrder") && promptElement.attr("data-original-value") === promptElement.val();
                    },
                    isBlankBoolean: function (promptElement, promptElementData, value)
                    {
                        return promptElementData.fieldType === "Boolean" && Array.isArray(value) && value[0] === promptElementData.originalValue;
                    }
                };

                let foundValue = false;
                $.each(promptElements, function ()
                {
                    const promptElement = $(this);
                    const promptElementData = promptElement.data();
                    const value = getPromptValue(promptElement);

                    if (value !== null)
                    {
                        // Confirm this value isn't actually a blank value that's just encoded in a weird way.
                        let valueIsActuallyBlankValue = false;
                        $.each(typeSpecificTests, function (testName, test)
                        {
                            if (test(promptElement, promptElementData, value))
                            {
                                valueIsActuallyBlankValue = true;
                                return false; // break $.each
                            }
                        });

                        if (!valueIsActuallyBlankValue)
                        {
                            foundValue = true;
                            return false; // break $.each
                        }
                    }
                });
                return foundValue;
            }

            function getPromptBoundValuesDictionary()
            {
                findAllPromptElements();
                const promptBoundValues = {};
                $.each(promptElements, function ()
                {
                    const jqThis = $(this);
                    const key = jqThis.data("promptUniqueId");
                    const value = getPromptValue(jqThis);
                    if (value !== null)
                    {
                        promptBoundValues[key] = value;
                    }
                });
                return promptBoundValues;
            }

            function getPromptValue(prompt)
            {
                let value = skyward.controls.getValue(prompt);

                // Crystal multiselects return an Array
                if (value instanceof Array)
                {
                    if (value.find(function (v) { return !blankValues.includes(v); }) === undefined)
                    {
                        return null;
                    }

                    return value;
                }

                if (value instanceof Date)
                {
                    if (!skyward.datepicker.isValidDateObject(value))
                    {
                        return null;
                    }
                    value = skyward.time.formatServerDate(value);
                }

                if (value instanceof Object)
                {
                    return Object.entries(value);
                }
                else if (!blankValues.includes(value))
                {
                    // Values that are returned as simple values
                    return [[value, value]];
                }

                return null;
            }

            return { init: init };
        }

        skyward.window.registerLoadDOMCallback(init);
    })(skyward || {}, window.jQuery);

